export function daysRange(from, days) {
  const dates = []

  for (let i = 0; i < days; i++) {
    dates.push(from.subtract(i, 'days').format('YYYY-MM-DD'))
  }

  return dates
}
